



































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class ConfirmModal extends Vue {
  @Prop({
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    default: () => {},
  })
  public confirmAction!: any;

  @Prop({
    default: false,
  })
  public uncancellableActionWarning!: boolean;

  @Prop({
    default: 'Ok',
  })
  public okActionBtnText!: string;

  @Prop({
    default: '',
  })
  public body!: string;

  @Prop({
    default: '',
  })
  public bodyHtml!: string;

  @Prop()
  public title!: string;

  public isModalActive = false;
  public actionInProgress = false;

  public cancel(): void {
    this.$emit('close');
  }

  public async confirm(): Promise<void> {
    this.actionInProgress = true;

    try {
      await this.confirmAction();
      this.$emit('close');
    } catch (e) {}

    this.actionInProgress = false;
  }
}
